import { OnInit, Component, OnDestroy } from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {first} from "rxjs";
import {ConcessionService} from "../../core/services/concession.service";
import {UTILS} from "../../core/const/const";
import {ViewportScroller} from "@angular/common";
import {SeoTagsService} from "../../core/services/seo-tags.service";

@Component({
  selector: 'app-agence-by-tdm',
  templateUrl: './agence-by-tdm.component.html',
  styleUrls: ['./agence-by-tdm.component.scss']
})
export class AgenceByTdmComponent implements OnInit, OnDestroy {
  nomAgence: string | null = null;
  dataAgence: any;
  infoAgence: any;
  current: number = 1;
  perPage: number = 6;
  total: number = 0;
  limiteTexte: number = 500;
  isTexteCollapsed: boolean = false;
  article: any = {
    titre: null,
    texte: null,
    image: null,
    urlimg: null
  };

  constructor(
    private route: ActivatedRoute,
    private serviceConcession: ConcessionService,
    private router: Router,
    private viewportScroller: ViewportScroller,
    private _seoTags: SeoTagsService
    ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.nomAgence = params.get('nomAgence');
      this.getInfoAgence();
    });
  }
  get biensPaginated() {
    const start = (this.current - 1) * this.perPage;
    const end = start + this.perPage;

    return this.dataAgence?.biens?.slice(start, end) ?? [];
  }
  getInfoAgence() {
    this.serviceConcession
      .getDetailAgenceBytdm(this.nomAgence)
      .pipe(first())
      .subscribe(
        (response: any) => {
          this.dataAgence = response.data;
          this.infoAgence = this.dataAgence?.agence?.info;
          this.article = this.dataAgence?.agence?.article;
          this.total = Math.ceil(this.dataAgence?.biens?.length / this.perPage);
          this.appliqueBalisesSeo();
        },
        (err) => {
          // window.open('https://thedoorman-recrute.fr/', '_self');
        }
      );
  }

  /**
   * Balises du <head> de la page d'agence byTDM : titre, description, partage
   * social, URL canonique et données structurées JSON-LD.
   *
   * Tout vient de la clé « seo » de l'API, calculée par le back
   * (App\Service\Seo\ClubSeo) — le même service qui alimente la page d'une
   * concession et la page HTML rendue aux robots d'IA.
   *
   * Ce que ça corrige : le titre était construit ici, en TypeScript, alors que le
   * back le construisait déjà pour les robots d'IA. Deux calculs pour un même
   * fait, donc deux titres possibles pour une même agence. La page ne déclarait
   * par ailleurs ni URL canonique, ni données structurées, et son og:url restait
   * celui d'index.html — tout partage renvoyait à la page d'accueil.
   *
   * Le repli reprend l'ancien calcul : les deux dépôts se déploient séparément, la
   * clé « seo » peut donc manquer le temps d'une mise en production.
   */
  private appliqueBalisesSeo() {
    const nom = this.infoAgence?.nom ?? this.dataAgence?.agence?.nom;
    const ville = this.dataAgence?.agence?.ville;
    const localisation = ville
      ? `Agence immobilière à ${ville}`
      : 'Agence immobilière';

    this._seoTags.apply(this.dataAgence?.seo, {
      title: [nom, localisation].filter(Boolean).join(' - ') + ' | The Door Man',
      description: this.dataAgence?.seodata?.description,
    });
  }

  ngOnDestroy() {
    // Sans ça, le JSON-LD et le canonical de cette agence resteraient dans le
    // document pendant la navigation vers la page suivante.
    this._seoTags.clear();
  }

  onBienClicked(bien: any) {
    let link = '/' +
      (bien.vente ? 'biens-a-vendre' : 'biens-a-louer') + '/' +
      UTILS.replaceSpace(bien.type) + '/' +
      UTILS.replaceSpace(bien.ville) + '/' +
      bien.property.pieces +
      (bien.property.pieces > 1 ? '-pieces/' : 'piece/') +
      bien.property.room +
      (bien.property.room > 1 ? '-chambres/' : '-chambre/') +
      bien.id;
    void this.router.navigate([link]);
  }
  doRefreshList(event: any) {
    this.route.params.subscribe((params: Params) => {
    });
  }
  onGoTo(page: number): void {
    this.current = page;
    this.viewportScroller.scrollToAnchor('ancre-mes-bien');
  }

  onNext(page: number): void {
    this.current = page + 1;
    this.viewportScroller.scrollToAnchor('ancre-mes-bien');
  }

  onPrevious(page: number): void {
    this.current = page - 1;
    this.viewportScroller.scrollToAnchor('ancre-mes-bien');
  }
}
